import { MenuItem, Select } from '@mui/material';
import dayjs from 'dayjs';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DEBUG, languageList } from 'utils/constants';

export const DebugLangSelector = () => {
  const { i18n } = useTranslation();

  const [isHidden, setIsHidden] = useState(true);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'l') {
      setIsHidden((prev) => !prev);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  if (!DEBUG || isHidden) return null;

  return (
    <Select
      value={i18n.language}
      onChange={(e) => {
        i18n.changeLanguage(e.target.value);
        dayjs.locale(e.target.value);
      }}
      size="small"
      sx={{
        position: 'fixed',
        top: 8,
        left: 8,
        zIndex: 9999,
        backgroundColor: 'white',
      }}
    >
      {languageList.map((language) => (
        <MenuItem value={language} key={language}>
          {language}
        </MenuItem>
      ))}
    </Select>
  );
};
